<template>
  <b-container fluid class="p-0 mt-2">
    <b-card class="mx-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold"
            >{{
              !!isPropDetalhe ? "Detalhes de" : idEmenda ? "Editar" : "Criar"
            }}
            Emenda</span
          >
          <b-badge
            v-if="!!isPropDetalhe && emenda.FlAtivo !== undefined"
            class="ml-2 emenda-status-badge"
            :class="{ 'is-inactive': !isEmendaAtiva(emenda.FlAtivo) }"
          >
            {{ isEmendaAtiva(emenda.FlAtivo) ? "Ativa" : "Inativa" }}
          </b-badge>
        </h6>
      </template>
      <b-tabs no-card>
        <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
          <b-form class="ml-4 mr-3" @submit.prevent="handleSubmit(salvar)">
            <h6 class="mb-3 mr-3 text-left">
              <btn-voltar />
              <b-button
                v-if="!isPropDetalhe"
                class="float-right m-1"
                size="sm"
                type="submit"
              >
                <font-awesome-icon icon="save" />
                Salvar
              </b-button>
            </h6>
            <b-row class="w-100">
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Nº da Emenda"
                >
                  <b-form-input
                    id="input-numero-emenda"
                    v-model="emenda.NrEmenda"
                    :state="defaultState.state"
                    :maxlength="maxLengthNrEmenda"
                    :disabled="!!isPropDetalhe"
                    autofocus
                    @change="regexNrEmenda"
                  />
                  <b-tooltip
                    :show.sync="showNrEmendaTooltip"
                    target="input-numero-emenda"
                    placement="bottom"
                  >
                    Deve conter apenas números.
                  </b-tooltip>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Ano da Emenda"
                >
                  <b-form-select
                    id="select-ano-emenda"
                    :state="defaultState.state"
                    :options="listaAnos"
                    v-model="emenda.NrAnoEmenda"
                    :disabled="!!isPropDetalhe"
                    @change="mudaListaAutores"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col
                :cols="emenda.IdTipoEmenda === 1 ? '6' : '12'"
                :lg="emenda.IdTipoEmenda === 1 ? '3' : '6'"
              >
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Tipo da Emenda"
                >
                  <b-form-select
                    id="tipo-emenda"
                    :state="defaultState.state"
                    :options="listaTiposEmenda"
                    v-model="emenda.IdTipoEmenda"
                    :disabled="!!isPropDetalhe"
                    @change="mudaListaAutores"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col v-if="emenda.IdTipoEmenda === 1" cols="6" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Transferência Especial (Emenda PIX)"
                >
                  <b-form-select
                    id="transf-esp"
                    :state="defaultState.state"
                    :options="listaTransEsp"
                    v-model="pgmntEspecial"
                    :disabled="!!isPropDetalhe"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col
                cols="12"
                lg="6"
                v-if="emenda.NrAnoEmenda && emenda.IdTipoEmenda"
              >
                <default-form-validation-provider
                  label="Autor(a)"
                  v-slot="defaultState"
                >
                  <b-overlay :show="loadingAutores">
                    <b-form-select
                      id="autor-emenda"
                      :state="defaultState.state"
                      :options="listaAutores"
                      v-model="emenda.IdAutor"
                      :disabled="!!isPropDetalhe"
                      @change="mudaListaBanco"
                    />
                  </b-overlay>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  label="Data da Emenda"
                  v-slot="defaultState"
                >
                  <div class="date-wrapper">
                    <b-input-group class="date-input-group">
                      <b-form-input
                        id="input-data-emenda"
                        v-model="dtEmendaInput"
                        v-maska="'##/##/####'"
                        :state="defaultState.state"
                        v-bind="dtEmendaInputProps"
                        @input="onDtEmendaDigitada"
                        @blur="commitDtEmendaInput"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          id="input-data-emenda-picker"
                          v-model="emenda.DtEmenda"
                          button-only
                          right
                          v-bind="datePickerProps"
                          :max="maxDate"
                          :disabled="!!isPropDetalhe"
                          button-variant="outline-secondary"
                          @input="syncDtEmendaInput"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3" v-if="emenda.IdAutor && isPropDetalhe">
                <default-form-validation-provider
                  label="Situação"
                  v-slot="defaultState"
                >
                  <b-form-input
                    :state="defaultState.state"
                    :value="isEmendaAtiva(emenda.FlAtivo) ? 'Ativa' : 'Inativa'"
                    disabled
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3" v-if="emenda.IdAutor">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Banco"
                >
                  <b-overlay :show="loadingBancos">
                    <b-form-select
                      id="banco-emenda"
                      :state="defaultState.state"
                      :options="listaBancos"
                      v-model="emenda.CdBanco"
                      :disabled="!!isPropDetalhe"
                    />
                  </b-overlay>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  label="Nº da Agência"
                  v-slot="defaultState"
                >
                  <b-form-input
                    id="input-agencia"
                    v-model="emenda.NrAgenciaBancaria"
                    :state="defaultState.state"
                    maxlength="6"
                    :disabled="!!isPropDetalhe"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  label="Nº da Conta"
                  v-slot="defaultState"
                >
                  <b-form-input
                    id="input-nro-conta"
                    v-model="emenda.NrContaBancaria"
                    :state="defaultState.state"
                    :disabled="!!isPropDetalhe"
                    maxlength="15"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  label="Valor da Emenda"
                  v-slot="defaultState"
                >
                  <money
                    class="form-control"
                    v-model="emenda.VlEmenda"
                    :state="defaultState.state"
                    v-bind="vMoneyOptions"
                    :disabled="!!isPropDetalhe"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <default-form-validation-provider
                  label="Extrato OFX"
                  v-slot="defaultState"
                  :rules="!!nomeArquivoExtrato ? '' : 'required'"
                >
                  <upload-anexo-com-acoes
                    :value="emenda.ArquivoExtratoForm"
                    @input="emenda.ArquivoExtratoForm = $event"
                    :placeholder="
                      nomeArquivoExtrato ?? 'Nenhum arquivo selecionado'
                    "
                    accept="application/ofx"
                    :state="defaultState.state || !!nomeArquivoExtrato"
                    :disabled="!!isPropDetalhe"
                    :nome-arquivo-existente="nomeArquivoExtrato"
                    :pode-baixar="!!idEmenda && !!nomeArquivoExtrato"
                    :pode-excluir="!isPropDetalhe"
                    @change="resetOfxName"
                    @download-existente="
                      nomeArquivoExtrato
                        ? baixarAnexo('extrato', nomeArquivoExtrato)
                        : null
                    "
                    @remove-existente="removerAnexoExistente('extrato')"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="6">
                <default-form-validation-provider
                  label="Plano de Ação da Emenda (PDF)"
                  v-slot="defaultState"
                  :rules="!!nomeArquivoPlanoTrabalho ? '' : 'required'"
                >
                  <upload-anexo-com-acoes
                    :value="emenda.ArquivoPlanoTrabalhoForm"
                    @input="emenda.ArquivoPlanoTrabalhoForm = $event"
                    :placeholder="
                      nomeArquivoPlanoTrabalho ?? 'Nenhum arquivo selecionado'
                    "
                    accept="application/pdf"
                    :state="defaultState.state || !!nomeArquivoPlanoTrabalho"
                    :disabled="!!isPropDetalhe"
                    :nome-arquivo-existente="nomeArquivoPlanoTrabalho"
                    :pode-baixar="!!idEmenda && !!nomeArquivoPlanoTrabalho"
                    :pode-excluir="!isPropDetalhe"
                    @change="resetPtName"
                    @download-existente="
                      nomeArquivoPlanoTrabalho
                        ? baixarAnexo('plano', nomeArquivoPlanoTrabalho)
                        : null
                    "
                    @remove-existente="removerAnexoExistente('plano')"
                  />
                </default-form-validation-provider>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import UploadAnexoComAcoes from "@/components/shared/UploadAnexoComAcoes.vue";
import { SelectValue } from "@/types/select-value";
import { Money } from "v-money";
import emendaService from "@/services/entregas/emendaService";
import autorService from "@/services/administracao/autorService";
import { Emenda } from "@/types/entregas/emendas/emenda";
import { store } from "@/store";
import { Autor } from "@/types/administracao/autor/autor";
import { EnumTipoEmenda } from "@/types/entregas/emendas/enum-tipo-emenda";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import { EnumTipoAutor } from "@/types/entregas/emendas/enum-tipo-autor";

const CompProps = Vue.extend({
  name: "EditarEmendas",
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
    BtnVoltar,
    UploadAnexoComAcoes,
    Money,
  },
  props: {
    idEmenda: {
      type: String,
      required: false,
    },
    isDetalhe: {
      type: String, // TODO: ver pq n tá aceitando Boolean
      required: false,
      default: "",
    },
  },
});

@Component
class EditarEmendas extends mixins(UtilsTS, CompProps) {
  camposExtratoOriginais: {
    DtEmenda: string;
    CdBanco: string;
    NrAgenciaBancaria: string;
    NrContaBancaria: string;
    VlEmenda: string;
  } | null = null;
  isInicializandoDadosEmenda = false;

  loading = false;
  emenda = new Emenda();
  listaTiposEmenda: SelectValue[] = [];
  listaAutores: SelectValue[] = [];
  listaBancos: SelectValue[] = [];
  nomeArquivoExtrato: string | null = null;
  nomeArquivoPlanoTrabalho: string | null = null;
  isPropDetalhe = String(false);

  overlayBaixar = false;
  loadingAutores = false;
  loadingBancos = false;
  showNrEmendaTooltip = false;

  autoresGlobal: Autor[] = [];

  pgmntEspecial: number | null = null;
  listaTransEsp: SelectValue[] = [
    { text: "Selecione", value: null },
    { text: "Sim", value: 1 },
    { text: "Não", value: 2 },
  ];
  listaAnos: SelectValue[] = [];
  dtEmendaInput = "";

  datePickerProps = DatePickerDefaultProps;
  maxDate = new Date();

  get dtEmendaInputProps() {
    return {
      ...this.dateMaskedInputProps,
      disabled: !!this.isPropDetalhe,
    };
  }

  get maxLengthNrEmenda() {
    const numMax = this.autoresGlobal.some(
      (a) =>
        a.IdAutor === this.emenda.IdAutor &&
        a.IdTipoAutor === EnumTipoAutor.DEPUTADO_ESTADUAL
    )
      ? 20
      : 8;
    if (this.emenda.NrEmenda && this.emenda.NrEmenda.length > numMax)
      this.emenda.NrEmenda = "";
    return numMax;
  }

  @Watch("emenda.DtEmenda")
  onDtEmendaValueChange(): void {
    this.syncDtEmendaInput();
  }

  mounted() {
    if (this.idEmenda) {
      this.camposExtratoOriginais = this.gerarSnapshotExtrato();
    }
  }

  async created() {
    try {
      store.blockScreen = true;
      this.isPropDetalhe = this.isDetalhe;
      await this.getListaAutores();
      this.getListaAnos(this.autoresGlobal);
      await this.getListaTiposEmenda();
      if (this.idEmenda) {
        this.isInicializandoDadosEmenda = true;
        try {
          await this.getEmendaById();
          const idAutor = this.emenda.IdAutor;
          this.mudaListaAutores();
          this.emenda.IdAutor = idAutor ?? null;
          const idBanco = this.emenda.CdBanco;
          this.mudaListaBanco();
          this.emenda.CdBanco = idBanco ?? null;
          this.camposExtratoOriginais = this.gerarSnapshotExtrato();
        } finally {
          this.isInicializandoDadosEmenda = false;
        }
      }
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      store.blockScreen = false;
    }
  }

  async getEmendaById() {
    try {
      this.emenda = await emendaService.getEmendaById(Number(this.idEmenda));
      this.nomeArquivoExtrato = this.nameByPath(this.emenda.PathArquivoExtrato);
      this.nomeArquivoPlanoTrabalho = this.nameByPath(
        this.emenda.PathArquivoPlanoTrabalho
      );
      this.pgmntEspecial =
        this.emenda.IdTipoEmenda === EnumTipoEmenda.INDIVIDUAL
          ? this.emenda.FlPagamentoEspecial
            ? 1
            : 2
          : null;
      this.camposExtratoOriginais = this.gerarSnapshotExtrato();
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  async getListaTiposEmenda() {
    try {
      const response = await emendaService.getTiposEmenda();
      this.listaTiposEmenda = response.map(
        (i: { Id: number; Descricao: string }) => {
          return { text: i.Descricao, value: i.Id };
        }
      );
      this.listaTiposEmenda.unshift({
        value: null,
        text: "Selecione o tipo da emenda",
      });
      this.emenda.IdTipoEmenda = null;
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  async getListaAutores() {
    try {
      this.loadingAutores = true;
      const autores = await autorService.getAutores();
      this.autoresGlobal = autores;
      this.listaAutores = autores.map((a) => {
        return { value: a.IdAutor, text: a.NmAutor };
      });
      this.listaAutores.unshift({
        value: null,
        text: "Selecione o(a) autor(a)",
      });
      this.emenda.IdAutor = null;
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingAutores = false;
    }
  }

  getListaAnos(autores: Autor[]): void {
    const menorAno = autores.reduce(
      (min, autor) =>
        autor.NrAnoInicioMandato < min ? autor.NrAnoInicioMandato : min,
      autores[0].NrAnoInicioMandato
    );
    const anoAtual = new Date().getFullYear();
    for (let ano = menorAno; ano <= anoAtual; ano++)
      this.listaAnos.push({ text: String(ano), value: ano });
    this.listaAnos.push({ text: "Selecione o ano", value: null });
    this.listaAnos.reverse();
    this.emenda.NrAnoEmenda = null;
  }

  // Esqueça papai aqui o cara é senioooorr vapo vapo
  mudaListaAutores() {
    this.loadingAutores = true;
    const autores = this.autoresGlobal ?? [];
    const lista = autores
      .filter(
        (a) =>
          this.emenda.NrAnoEmenda &&
          a.NrAnoInicioMandato <= this.emenda.NrAnoEmenda &&
          this.emenda.NrAnoEmenda <= a.NrAnoFimMandato
      )
      .filter((a) => {
        switch (this.emenda.IdTipoEmenda) {
          case EnumTipoEmenda.INDIVIDUAL:
            return [
              EnumTipoAutor.DEPUTADO_FEDERAL,
              EnumTipoAutor.DEPUTADO_ESTADUAL,
              EnumTipoAutor.SENADOR,
            ].includes(a.IdTipoAutor as number);
          case EnumTipoEmenda.RELATOR:
            return [EnumTipoAutor.RELATOR].includes(a.IdTipoAutor as number);
          case EnumTipoEmenda.BANCADA:
            return [EnumTipoAutor.BANCADA].includes(a.IdTipoAutor as number);
          case EnumTipoEmenda.COMISSAO:
            return [EnumTipoAutor.COMISSAO].includes(a.IdTipoAutor as number);
          default:
            return false;
        }
      })
      .map((a) => ({ value: a.IdAutor, text: a.NmAutor }));
    this.listaAutores = [
      { value: null, text: "Selecione o(a) autor(a)" },
      ...lista,
    ];
    this.emenda.IdAutor = null;
    this.loadingAutores = false;
  }

  mudaListaBanco() {
    this.loadingBancos = true;
    const isEstadual = this.autoresGlobal.find(
      (a) =>
        a.IdAutor === this.emenda.IdAutor && a.TipoAutor === "Deputado Estadual"
    );
    if (isEstadual) {
      this.listaBancos = [
        { value: null, text: "Selecione o banco" },
        { value: 1, text: "001 - Banco do Brasil" },
        { value: 4, text: "004 - Banco do Nordeste do Brasil" },
        { value: 47, text: "047 - Banco Banese" },
        { value: 104, text: "104 - Caixa Econômica Federal" },
      ];
    } else {
      this.listaBancos = [
        { value: null, text: "Selecione o banco" },
        { value: 1, text: "001 - Banco do Brasil" },
        { value: 4, text: "004 - Banco do Nordeste do Brasil" },
        { value: 104, text: "104 - Caixa Econômica Federal" },
      ];
    }
    this.emenda.CdBanco = null;
    this.loadingBancos = false;
  }

  onDtEmendaDigitada(value: string): void {
    this.dtEmendaInput = value;
    if (!value) {
      this.emenda.DtEmenda = null;
      return;
    }

    if (value.length === 10) {
      const parsedDate = this.parseDtEmendaInput(value);
      this.emenda.DtEmenda =
        parsedDate && parsedDate <= this.maxDate ? parsedDate : null;
    }
  }

  commitDtEmendaInput(): void {
    if (!this.dtEmendaInput) {
      this.emenda.DtEmenda = null;
      return;
    }

    const parsedDate = this.parseDtEmendaInput(this.dtEmendaInput);
    if (!parsedDate || parsedDate > this.maxDate) {
      this.emenda.DtEmenda = null;
      return;
    }

    this.emenda.DtEmenda = parsedDate;
    this.dtEmendaInput = this.formatDtEmendaInput(parsedDate);
  }

  syncDtEmendaInput(): void {
    this.dtEmendaInput = this.formatDtEmendaInput(this.emenda.DtEmenda);
  }

  parseDtEmendaInput(value: string): Date | null {
    const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) return null;

    const [, day, month, year] = match;
    const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
    const isValidDate =
      parsedDate.getFullYear() === Number(year) &&
      parsedDate.getMonth() === Number(month) - 1 &&
      parsedDate.getDate() === Number(day);

    return isValidDate ? parsedDate : null;
  }

  formatDtEmendaInput(value: Date | null): string {
    if (!(value instanceof Date) || isNaN(value.getTime())) return "";

    const day = String(value.getDate()).padStart(2, "0");
    const month = String(value.getMonth() + 1).padStart(2, "0");
    return `${day}/${month}/${value.getFullYear()}`;
  }

  regexNrEmenda() {
    const nrEmendaAntes = this.emenda.NrEmenda;
    this.emenda.NrEmenda = this.emenda.NrEmenda.replace(/\D/g, "");
    if (this.emenda.NrEmenda.length < nrEmendaAntes.length) {
      this.showNrEmendaTooltip = true;
      setTimeout(() => {
        this.showNrEmendaTooltip = false;
      }, 3000);
    }
  }

  async salvar() {
    this.emenda.NrEmenda = this.emenda.NrEmenda.replace(/\D/g, "");
    if (!this.emenda.NrEmenda)
      return this.$toast.error("O número da emenda é obrigatório.");
    if (this.isPropDetalhe) return;
    this.commitDtEmendaInput();
    this.emenda.FlPagamentoEspecial =
      this.emenda.IdTipoEmenda === EnumTipoEmenda.INDIVIDUAL
        ? this.emenda.FlPagamentoEspecial
        : false;
    this.emenda.FlPagamentoEspecial = this.pgmntEspecial === 1;
    try {
      this.emenda = new Emenda(this.emenda);
      this.camposExtratoOriginais = this.gerarSnapshotExtrato();
      const response = await emendaService.saveEmenda(this.emenda);
      this.$toast.success(
        `Emenda ${response.NrEmenda}/${response.NrAnoEmenda} salva com sucesso!`
      );
      this.isPropDetalhe = String(true);
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  async baixarAnexo(tipo: string, nomeArquivo: string) {
    try {
      this.overlayBaixar = true;
      const response = await emendaService.baixarAnexoEmenda(
        Number(this.idEmenda),
        tipo
      );
      this.download(nomeArquivo, response);
    } catch (error: unknown) {
      this.tratarError(error);
      console.error(error);
    } finally {
      this.overlayBaixar = false;
    }
  }

  download(filename: string, content: any): void {
    var element = document.createElement("a");
    element.setAttribute("href", URL.createObjectURL(content));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  nameByPath(path: string): string {
    const part = path.split("\\");
    return part[part.length - 1];
  }

  resetOfxName() {
    this.nomeArquivoExtrato = null;
  }

  isEmendaAtiva(val: unknown): boolean {
    if (val === true || val === 1 || val === "1") return true;
    if (val === "S" || val === "Sim" || val === "true") return true;
    return false;
  }

  resetPtName() {
    this.nomeArquivoPlanoTrabalho = null;
  }

  @Watch("emenda.DtEmenda")
  @Watch("emenda.CdBanco")
  @Watch("emenda.NrAgenciaBancaria")
  @Watch("emenda.NrContaBancaria")
  @Watch("emenda.VlEmenda")
  onCamposImpactamExtrato() {
    this.validarAlteracoesQueExigemNovoOfx();
  }

  validarAlteracoesQueExigemNovoOfx() {
    // Regra de negócio: ao alterar dados que impactam a conciliação do OFX, forçamos reenvio.
    const isEdicao = !!this.idEmenda;
    const isDetalhe = this.isPropDetalhe === String(true);
    if (
      !isEdicao ||
      isDetalhe ||
      !this.camposExtratoOriginais ||
      this.isInicializandoDadosEmenda
    )
      return;

    const alterouCampoSensivel =
      JSON.stringify(this.camposExtratoOriginais) !==
      JSON.stringify(this.gerarSnapshotExtrato());

    if (
      alterouCampoSensivel &&
      (this.nomeArquivoExtrato || this.emenda.ArquivoExtratoForm)
    ) {
      this.limparExtrato();
      this.$toast.info(
        "Como os dados bancários/data/valor foram alterados, envie um novo Extrato OFX."
      );
    }
  }

  gerarSnapshotExtrato() {
    return {
      DtEmenda: this.normalizeSnapshotValue(this.emenda.DtEmenda),
      CdBanco: this.normalizeSnapshotValue(this.emenda.CdBanco),
      NrAgenciaBancaria: this.normalizeSnapshotValue(
        this.emenda.NrAgenciaBancaria
      ),
      NrContaBancaria: this.normalizeSnapshotValue(this.emenda.NrContaBancaria),
      VlEmenda: this.normalizeSnapshotValue(this.emenda.VlEmenda),
    };
  }

  normalizeSnapshotValue(valor: unknown) {
    if (valor === null || valor === undefined) return "";
    return String(valor).trim();
  }

  async removerAnexoExistente(tipo: "extrato" | "plano") {
    if (this.isPropDetalhe === String(true)) return;
    const confirmou = await this.$bvModal.msgBoxConfirm(
      "Deseja realmente remover o anexo selecionado?",
      {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        okVariant: "secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Remover",
        title: "Remoção de Anexo",
      }
    );
    if (!confirmou) return;

    if (tipo === "extrato") {
      this.limparExtrato();
      return;
    }

    this.nomeArquivoPlanoTrabalho = null;
    this.emenda.PathArquivoPlanoTrabalho = "";
    this.emenda.ArquivoPlanoTrabalhoForm = undefined as any;
  }

  limparExtrato() {
    // Limpa tanto referência visual quanto payload do FormData para evitar envio acidental do OFX anterior.
    this.nomeArquivoExtrato = null;
    this.emenda.PathArquivoExtrato = "";
    this.emenda.ArquivoExtratoForm = undefined as any;
    this.camposExtratoOriginais = this.gerarSnapshotExtrato();
  }
}

export default EditarEmendas;
</script>
<style scoped>
.emenda-status-badge {
  background-color: var(--baseColor);
  color: #fff;
  font-weight: 600;
}

.emenda-status-badge.is-inactive {
  background-color: #e9ecef;
  color: var(--baseColor);
  border: 1px solid var(--baseColor);
}

/* DATEPICKER */
.date-wrapper {
  width: 100%;
}

.date-wrapper ::v-deep .date-input-group {
  width: 100% !important;
}

.date-wrapper ::v-deep .date-input-group > .form-control {
  height: 38px !important;
  min-height: 38px !important;
}

.date-wrapper ::v-deep .date-input-group > .input-group-append,
.date-wrapper
  ::v-deep
  .date-input-group
  > .input-group-append
  > .b-form-datepicker {
  height: 38px !important;
}

.date-wrapper
  ::v-deep
  .date-input-group
  > .input-group-append
  > .b-form-datepicker
  > .btn {
  width: 42px !important;
  height: 38px !important;
  min-height: 38px !important;
  padding: 0 12px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
